module.exports = __webpack_public_path__ + "img/2.848e71a2.jpg";